import axios from 'axios'
import HTTP from './http'

export default {
    list: payload => axios.get(HTTP.COLLECTION_CLINIC_SERVICES_LIST, { params: payload })
}
